
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53.75 57.277"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.375 0h-43A5.356 5.356 0 000 5.375v32.25A5.375 5.375 0 005.375 43h11.718l-.178-1.417a2.671 2.671 0 01.65-2.1 2.644 2.644 0 01.708-.57c-.092-.83-.196-1.894-.196-2.434 0-2.738.81-5.878 7.026-6.068a9.637 9.637 0 015.358-1.37c3.27 0 4.898 1.432 5.687 2.634 1.632 2.497.611 4.216-.139 5.018l-.358.358-.094 1.912a2.667 2.667 0 011.283 2.617L36.663 43h11.713a5.375 5.375 0 005.375-5.375V5.375A5.373 5.373 0 0048.375 0zm0 10.125L26.875 22l-21.5-11.875v-4.75l21.5 11.875 21.5-11.875z"}}),_c('path',{staticClass:"user",attrs:{"d":"M35.282 50.12l-3.718-.93-.206-.823a7.722 7.722 0 001.916-3.794 2.05 2.05 0 001.18-1.606l.262-2.09a2.042 2.042 0 00-.982-2.004l.072-1.464.274-.274a2.879 2.879 0 00.106-3.842 4.826 4.826 0 00-4.354-2.016 7.38 7.38 0 00-4.102 1.048c-4.76.146-5.38 2.55-5.38 4.646 0 .414.08 1.228.15 1.864a2.052 2.052 0 00-1.04 2.044l.262 2.086a1.998 1.998 0 001.304 1.632 7.773 7.773 0 001.816 3.672l-.23.922-3.718.93a6.334 6.334 0 00-4.808 6.156 1 1 0 001 1h24a1.002 1.002 0 001-1.002 6.332 6.332 0 00-4.804-6.154z"}})])
          )
        }
      }
    